


// import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin(() => {
  const eventBus = useEventStore();
  return {
    provide: {
      eventBus: {
        $on: eventBus.on,
        $emit: eventBus.emit,
      },
    },
  };
});
